<div class="container">
    <ng-container>
        <div class="line">
            <div class="item">
                <div style="display:table-cell">Start Date:</div>
                <dx-date-box  style="display:table-cell" type="date" [value]="selectedStartDate" (onValueChanged)="dateChangedStart($event)">
                </dx-date-box>
            </div>
            <div class="item">
                <div style="display:table-cell">End Date:</div>
                <dx-date-box style="display:table-cell" type="date" [value]="selectedEndDate" (onValueChanged)="dateChangedEnd($event)">
                </dx-date-box>
            </div>
            <div class="item">
                <button (click)="yesterdayClickHandler()" [innerText]="'Yesterday'"></button>
            </div>
            <div class="item">
                <button (click)="todayClickHandler()" [innerText]="'Today'"></button>
            </div>
            <div class="item">
                <button (click)="tomorrowClickHandler()" [innerText]="'Tomorrow'"></button>
            </div>
            <div class="item">
                <button (click)="createNewOrder()" class="new-order-btn">New Order</button>
            </div>
        </div>

        <dx-data-grid
            id="dataGrid"
            [dataSource]="dataSource"
            [remoteOperations]="false"
            [showBorders]="true"
            [allowColumnResizing]="true"
            [columnAutoWidth]="true"
            (onRowClick)="onRowClick($event)"
            >
            <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
            <dxo-group-panel [visible]="true" [allowColumnDragging]="true"></dxo-group-panel>

            <!-- Custom group cell template -->
            <div *dxTemplate="let groupInfo of 'groupCellTemplate'">
                <div style="display: flex; width: 100%; justify-content: space-between;">
                    <span>{{ groupInfo.value }}</span>
                    <div>
                        <dx-button
                        icon="edit"
                        stylingMode="text"
                        (onClick)="editOrder(groupInfo.data.items[0].orderId); $event.event.stopPropagation()"
                        ></dx-button>
                        <dx-button
                        icon="close"
                        stylingMode="text"
                        (onClick)="deleteOrder(groupInfo.data.items[0].orderId); $event.event.stopPropagation()"
                        ></dx-button>
                    </div>
                </div>
            </div>

            <dxi-column
                dataField="docId"
                caption="Id"
            ></dxi-column>
            <dxi-column
                dataField="customerPOnum"
                caption="Order"
                [groupIndex]="1"
                groupCellTemplate="groupCellTemplate"
            ></dxi-column>
            <dxi-column dataField="salesrep" caption="Company" [groupIndex]="0"></dxi-column>
            <dxi-column dataField="status" caption="Status"></dxi-column>
            <dxi-column dataField="scheduledDate" caption="Date"></dxi-column>
            <dxi-column dataField="itemsCount" caption="Items"></dxi-column>
            <dxi-column dataField="customerName" caption="Customer"></dxi-column>

            <!-- Row-level actions -->
            <!--<div *dxTemplate="let cell of 'actionsTemplate'">
                <dx-button
                icon="edit"
                stylingMode="text"
                (onClick)="editItem(cell); $event.event.stopPropagation()"
                ></dx-button>
                <dx-button
                icon="close"
                stylingMode="text"
                (onClick)="deleteItem(cell); $event.event.stopPropagation()"
                ></dx-button>
            </div>-->

            <dxi-column
                caption="Actions"
                [width]="100"
                [allowFiltering]="false"
                [allowSorting]="false"
                
            ></dxi-column>

            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            </dx-data-grid>

    </ng-container>
  
</div>

